import { API_URL, jwtToken } from "../../../context/appContext";
export default async function fetchSourceMarkets(exchange, is_sandbox, customUrl = null) {
    return fetch(`${API_URL}/api/source_market/${exchange}/${is_sandbox ? 1 : 0}?api=${customUrl?.custom_api_url}&socket=${customUrl?.custom_websocket_url}`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
